import styled, { css } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

import { SCREEN_WIDTH_THRESHOLD } from "./constants";

const spendAndImpressionsIcon = AssetsService.assetUrl("/images/ad-intelligence/spend-and-impressions-preview.png");

export const PerformanceWidgetsWrapper = styled.div`
    display: grid;
    gap: 24px;
    margin-bottom: 24px;
    grid-template-columns: 1fr 1fr 1fr;

    @media (max-width: ${SCREEN_WIDTH_THRESHOLD}px) {
        grid-template-columns: minmax(220px, 0.8fr) 1fr 1fr;
    }
`;

export const PerformanceOverTimeGraphContainer = styled.div`
    margin-bottom: 24px;
`;

export const WidgetContentContainer = styled.div`
    padding: 0 24px 24px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    > div {
        padding: 0;
        width: 100%;
    }
`;

export const SpendAndImpressionsContainer = styled(Stack).attrs((userDefinitions) => ({
    gap: "16px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "6px",
    boxSizing: "border-box",
    height: "100%",
    width: "100%",
    ...userDefinitions,
}))<{ $blurContent?: boolean }>`
    ${({ $blurContent = true }) =>
        $blurContent &&
        css`
            background: url(${spendAndImpressionsIcon}) no-repeat center center;
            background-size: cover;
        `}
`;
